import React from "react";

import Guest from "../../../layouts/Guest";
import NewYearCheckAdminForm from "views/Forms/Private/EventCheckForm/NewYearCheckAdminForm";

function NewYearCheckInSearchPage() {

  return (
    <>
      <Guest>
        <NewYearCheckAdminForm />
      </Guest>
    </>
  );
}

export default NewYearCheckInSearchPage;
